import type { FeatureKey } from '@/types';

export interface NavLinkDef {
  label: string;
  to: string;
  /** Hidden when the tenant has this module disabled. */
  feature?: FeatureKey;
}

export const mainNav: NavLinkDef[] = [
  { label: 'Home', to: '/' },
  { label: 'Products', to: '/products', feature: 'products' },
  { label: 'Categories', to: '/categories', feature: 'categories' },
  { label: 'Offers', to: '/offers', feature: 'coupons' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
];

export const accountNav: (NavLinkDef & { icon: string })[] = [
  { label: 'Overview', to: '/account', icon: 'layout' },
  { label: 'Orders', to: '/account/orders', icon: 'package', feature: 'orders' },
  { label: 'Wallet', to: '/account/wallet', icon: 'wallet', feature: 'wallet' },
  { label: 'Loyalty', to: '/account/loyalty', icon: 'gift', feature: 'loyalty' },
  { label: 'Coupons', to: '/account/coupons', icon: 'ticket', feature: 'coupons' },
  { label: 'Referrals', to: '/account/referrals', icon: 'users', feature: 'affiliate' },
  { label: 'Profile', to: '/account/profile', icon: 'user' },
];
